import { Component, Input, OnDestroy, OnInit, Optional } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BookingService } from "@estatex/services";
import { Booking, Requirement } from "@estatex/types";
import { Subject, takeUntil } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { Duration, intervalToDuration, format } from "date-fns";
import { SafeUrl, Title } from "@angular/platform-browser";
import { HeaderVersion, NavigationService } from "@estatex/services";
import { QRCodeModule } from "angularx-qrcode";
import { TuiButtonModule } from "@taiga-ui/core";
import { DateFormat, SITE_CONSTANTS } from "@estatex/types";

@Component({
    selector: "app-view-booking",
    standalone: true,
    imports: [CommonModule, QRCodeModule, TuiButtonModule],
    templateUrl: "./view-booking.component.html",
    styleUrl: "./view-booking.component.css",
})
export class ViewBookingComponent implements OnInit, OnDestroy {
    private readonly unsubscribe$ = new Subject<void>();
    @Input() bookingNumber: string;

    booking: Booking;
    requirement: Requirement;

    durationOfStay: Duration;

    bookingUrl: string;
    qrFileName: string;
    qrCodeDownloadLink: SafeUrl = "";

    constructor(
        private readonly bookingService: BookingService,
        private readonly route: ActivatedRoute,
        private readonly titleService: Title,
        private readonly navigationService: NavigationService
    ) {
        this.titleService.setTitle(SITE_CONSTANTS.VIEW_BOOKING);
        this.navigationService.setHeaderVersion(HeaderVersion.OPAQUE);
    }
    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        // this.navigationService.setHeaderVersion(HeaderVersion.TRANSPARENT);
    }

    ngOnInit(): void {
        this.bookingNumber = !!this.bookingNumber ? this.bookingNumber : this.route.snapshot.params["bookingNumber"];
        this.bookingUrl = window.document.URL;
        this.bookingService
            .getBooking(this.bookingNumber)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((booking) => {
                this.booking = booking;
                this.requirement = {
                    adults: booking.adults,
                    child: booking.child,
                    rooms: booking.rooms,
                    checkinDate: new Date(booking.checkinDate),
                    checkoutDate: new Date(booking.checkoutDate),
                };
                this.durationOfStay = intervalToDuration({ start: this.requirement.checkinDate, end: this.requirement.checkoutDate });
                this.qrFileName = `outlookinn-${format(booking.checkinDate, DateFormat["DD/MM/YYYY"])}-${format(
                    booking.checkoutDate,
                    DateFormat["DD/MM/YYYY"]
                )}`;
            });
    }

    onChangeURL(url: SafeUrl) {
        this.qrCodeDownloadLink = url;
    }
}
